import { lazy, Suspense, useEffect } from 'react';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../../../hooks';
import { USER_ROLE_ENUM } from '../../../interfaces';
import Spinner from '../../shared/spinner';
import PaymentMethods from './payment-methods';
import AddPaymentMethod from './payment-methods/add';
import EditPaymentMethod from './payment-methods/edit';

const Profile = lazy(() => import('./profile'));
const Properties = lazy(() => import('./properties'));
const AddProperty = lazy(() => import('./properties/add'));
const EditProperty = lazy(() => import('./properties/edit'));
const Users = lazy(() => import('./users'));
const Purchases = lazy(() => import('./purchases'));
const Invoice = lazy(() => import('../../shared/invoice'));

const User = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      window.location.href = '/';
    } else if (user && user.role !== USER_ROLE_ENUM.admin) {
      navigate(`/${user.role}/profile`);
    }
  }, []);

  return (
    <Suspense fallback={<Spinner text={'Loading...'}
                                 style={{ padding: '100px' }}/>}>
      <Routes>
        <Route path={'profile'} element={<Profile/>}/>
        <Route path={'properties'} element={<Properties/>}/>
        <Route path={'properties/add'} element={<AddProperty/>}/>
        <Route path={'properties/edit/:propertyID'} element={<EditProperty/>}/>
        <Route path={'payment/methods'} element={<PaymentMethods/>}/>
        <Route path={'payment/methods/add'} element={<AddPaymentMethod/>}/>
        <Route path={'payment/methods/edit/:paymentMethodID'} element={<EditPaymentMethod/>}/>
        <Route path={'users'} element={<Users/>}/>
        <Route path={'purchases'} element={<Purchases/>}/>
        <Route path={'purchases/invoice/:purchaseID'} element={<Invoice/>}/>
        <Route path={'*'} element={<Navigate to={'/not/found'}/>}/>
      </Routes>
    </Suspense>
  );
}

export default User;